import { PracticeScreen } from '@orthly/dentin';
import { ToolbarContainer } from '@orthly/ui';
import { Button, useScreenIsMd } from '@orthly/ui-primitives';
import React from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

/**
 * Renders the upper toolbar for use on the Patient Detail page (see [storybook](https://storybook-dev.dandyserv.net/main/practice/index.html?path=/story/patients-patient-detail-patientdetailtoolbar--patient-detail-toolbar)).
 */
export const PatientDetailToolbar: React.VFC = () => {
    const isMd = useScreenIsMd();
    const navigate = useNavigate();

    if (isMd) {
        return null;
    }

    return (
        <ToolbarContainer sticky style={{ padding: 0, top: 0 }}>
            <Button
                variant={'ghost'}
                startIcon={'ChevronLeft'}
                style={{ marginLeft: '12px' }}
                onClick={() => navigate(`/${PracticeScreen.patients}`)}
            >
                Back to patients
            </Button>
        </ToolbarContainer>
    );
};
